import React, { Fragment, useState, useEffect } from 'react';
import { useHistory, useParams, useRouteMatch, generatePath } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Loading from '../components/Loading';
import LoadError from '../components/LoadError';
import LeaderBoard from './LeaderBoard';
import Detail from './Detail';
import { GAME_RANKS } from '../../../config';
import { createAxios } from '../../../utils/utils';
import useLog from '../hooks/useLog';
import { scrollUse } from '../../../actions/game';

export default ({ source }) => {
  const dispatch = useDispatch();
  const [report, track] = useLog();
  const history = useHistory();
  const { code } = useParams();
  const { path } = useRouteMatch();

  const [ranks, setRanks] = useState([]);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    createAxios().then(axios => {
      axios
        .get(GAME_RANKS)
        .then(res => {
          if (res.data.status !== 0) throw new Error('no ranks.');

          let result = res.data.data || [];
          result = result.filter(rank => rank.apps && rank.apps.length > 0);

          if (result.length <= 0) throw new Error('no ranks.');

          setRanks(result);

          if (code !== undefined && !result.some(rank => rank.code === code)) {
            history.replace(generatePath(path, { code: result[0].code }));
          }
        })
        .catch(() => {
          setHasError(true);
        });
    });
  }, []);

  useEffect(() => {
    report('P', source, {
      source: code ? `${source}||${code}` : source,
    });

    track(0, code ? `${source}||${code}` : source);
  }, [code]);

  useEffect(() => {
    if (ranks.length <= 0) return;

    if (code === undefined) {
      dispatch(scrollUse(history.action));
    }
  }, [code, ranks]);

  useEffect(() => {
    let _StartTime = Date.now();
    return () => {
      report('I', 'View_Time', {
        source: source,
        time: Math.ceil((Date.now() - _StartTime) / 1000),
      });
    };
  }, []);

  return (
    <Fragment>
      {code !== undefined && ranks.some(rank => rank.code === code) && (
        <Detail source={source} code={code} ranks={ranks} />
      )}
      {code === undefined && ranks.length > 0 && (
        <Fragment>
          <div style={{ height: '16px' }} />
          <LeaderBoard tag={source} ranks={ranks} />
        </Fragment>
      )}
      {hasError && <LoadError />}
      {!hasError && ranks.length <= 0 && <Loading />}
    </Fragment>
  );
};
